'use client'

import LogRocket from 'logrocket'
import setupLogRocketReact from 'logrocket-react'
import { useEffect, useState } from 'react'

import { trackTenantSessionStart } from '@/lib/analytics/events'
import type { Tenant } from '@/services/http/tenantService/types'
import { LOGROCKET_SENSITIVE_ROUTES } from '@/utils/constants'
import { getTenantByCookies } from '@/utils/getTenantByCookies'
import { maskSensitiveFields } from '@/utils/sanitize'

export function LogRocketProvider() {
  const [tenant, setTenant] = useState<Tenant | null>(null)
  const [initialized, setInitialized] = useState(false)

  useEffect(() => {
    const appId = process.env.NEXT_PUBLIC_LOGROCKET_APP_ID
    if (!appId) return

    LogRocket.init(appId, {
      network: {
        requestSanitizer: (request) => {
          if (
            LOGROCKET_SENSITIVE_ROUTES.some((route) =>
              request.url.includes(route),
            )
          )
            return null
          request.body = maskSensitiveFields(request.body)
          return request
        },
        responseSanitizer: (response) => {
          response.body = maskSensitiveFields(response.body)
          return response
        },
      },
      console: {
        isEnabled: { error: true, warn: true, info: true, log: true },
      },
    })

    setupLogRocketReact()
    setInitialized(true)
  }, [])

  useEffect(() => {
    if (!initialized) return
    getTenantByCookies().then(setTenant)
  }, [initialized])

  useEffect(() => {
    if (!tenant || !initialized) return

    trackTenantSessionStart({
      tenantId: tenant.id,
      tenantName: tenant.name,
      tenantSlug: tenant.slug,
      tenantStatus: tenant.status,
    })
  }, [tenant, initialized])

  return null
}
